import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, Icon } from '@unite-us/ui';
var NavButtons = function NavButtons(_ref) {
  var onBackClick = _ref.onBackClick,
    onForwardClick = _ref.onForwardClick,
    onSaveDraftReferral = _ref.onSaveDraftReferral,
    primaryLabel = _ref.primaryLabel,
    hideForwardButtons = _ref.hideForwardButtons,
    hideSaveDraftLink = _ref.hideSaveDraftLink,
    hasOffPlatformReferrals = _ref.hasOffPlatformReferrals,
    disabled = _ref.disabled,
    hasDraftReferral = _ref.hasDraftReferral,
    crtb1239AdaptDraftReferralFlow = _ref.crtb1239AdaptDraftReferralFlow,
    _ref$isForwardReferra = _ref.isForwardReferralPath,
    isForwardReferralPath = _ref$isForwardReferra === void 0 ? false : _ref$isForwardReferra;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center responsive-max-width flex-col mx-auto mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "back",
    onClick: onBackClick,
    label: crtb1239AdaptDraftReferralFlow && hasDraftReferral ? "Draft Referral" : "Back",
    iconLeft: /*#__PURE__*/React.createElement(Icon, {
      icon: "V2ChevronLeft",
      color: "#182A44"
    }),
    className: "md:h-12 normal-case"
  }), !hideForwardButtons ? /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, !hideSaveDraftLink && !hasOffPlatformReferrals && !isForwardReferralPath && /*#__PURE__*/React.createElement("button", {
    className: "mr-10 text-current-blue font-bold",
    onClick: onSaveDraftReferral
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "V2Save",
    color: "#4467AB",
    className: "mr-2 mb-1"
  }), "Save Draft Referral(s)"), /*#__PURE__*/React.createElement(Button, {
    id: "submit",
    disabled: disabled,
    onClick: onForwardClick,
    className: "md:w-64 md:h-12 w-64 normal-case",
    label: primaryLabel,
    iconLeft: /*#__PURE__*/React.createElement(Icon, {
      icon: "V2Referrall",
      color: "#FFFFFF",
      className: "w-6 h-6 pr-2"
    }),
    primary: true
  })) : null));
};
NavButtons.propTypes = {
  onBackClick: PropTypes.func.isRequired,
  onForwardClick: PropTypes.func.isRequired,
  onSaveDraftReferral: PropTypes.func.isRequired,
  primaryLabel: PropTypes.string.isRequired,
  hideForwardButtons: PropTypes.bool,
  hideSaveDraftLink: PropTypes.bool,
  hasOffPlatformReferrals: PropTypes.bool,
  hasDraftReferral: PropTypes.bool,
  disabled: PropTypes.bool
};
NavButtons.defaultProps = {
  hideForwardButtons: false,
  hideSaveDraftLink: false,
  hasOffPlatformReferrals: false,
  disabled: false,
  hasDraftReferral: false
};
export default NavButtons;
//# sourceMappingURL=NavButtons.js.map